module.exports = __webpack_public_path__ + "img/logo.6539ab31.png";